<div nz-row class="metal-intro-image"></div>
<div class="metal-message" style="height: 380px;">
  <div class="content">
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 28px;">
      판금 사업부 소개<br />
    </div>
    <div style="font-weight: normal; font-size: 18px;">
      <p>
        당 사업부는 FMS S4+P4 라인을 도입하여, 기구 설계에서부터 생산, 조립에 이르기까지<br/>
        완벽한 일괄 생산 라인은 고객의 경쟁력 제고강화를 목표로 고객 맞춤 최적의 시스템을 구축하고 있습니다.<br/>
      </p>
    </div>
  </div>
</div>
<div class="metal-item-intro">
  <div>
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 38px; font-family: Roboto,sans-serif; padding-top: 100px;">
      Elevator Maching<br />
    </div>
    <div style="font-weight: normal; font-size: 18px;">
      <p>판금 사업부는 Laser, NCT, Bending M/C등 다량의 판금 장비를 보유하고 있습니다.<br /></p>
    </div>
  </div>
  <div style="padding-left: 200px; padding-right: 200px; padding-top: 50px;">
    <table style="width: 100%;">
      <tr style="border-top-style: solid; border-top-color: #585858; border-top-width: 2px;
          border-bottom-style: solid; border-bottom-color: #585858; border-bottom-width: 1px;
          font-family: 'Noto Sans',sans-serif; font-size: 16px;">
        <td style="width: 250px;">장비사진</td>
        <td style="width: 250px;">구분</td>
        <td style="width: 250px;">모델명</td>
        <td style="width: 250px;">제조업체</td>
      </tr>
      <tr class="product-container" *ngFor="let product of MetalProducts">
        <td><img src="{{product.imgUrl}}" /></td>
        <td>{{product.type}}</td>
        <td>{{product.model}}</td>
        <td>{{product.manufacturer}}</td>
      </tr>
    </table>
  </div>
</div>
<div style="height: 50px;"></div>
<div class="customer-center-footer" nz-row>
  <p nz-col>
    <label style="font-family: Roboto,sans-serif; font-size: 40px; font-weight: bold">Customer Center</label><br/>
    <label style="font-family: 'Noto Sans',sans-serif; font-size:20px;">문의 주시면 정성을 다해 상담 드리겠습니다</label>
  </p>
  <div class="arrow" nz-col (click)="onClickGotoRequest()"></div>
</div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
    [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
